<template>
  <div v-if="hasAvailableTutorials" class="tutorial-replay-wrapper">
    <Button
      data-testid="tutorial-replay-menu-btn"
      :label="isMobile ? '' : t('Tutoriais')"
      icon="pi pi-question-circle"
      severity="secondary"
      text
      size="small"
      @click="toggleMenu"
      :badge="pendingCount > 0 ? String(pendingCount) : undefined"
      badge-severity="info"
      data-tutorial="replay-button"
    />
    <Menu
      ref="menuRef"
      :model="menuItems"
      :popup="true"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useTutorial } from '../../composables/useTutorial'

interface MenuInstance {
  toggle: (event: Event) => void;
}

interface MenuItem {
  label: string;
  icon: string;
  command: () => void;
}

const { t } = useI18n()
const { availableTutorials, hasAvailableTutorials, replay } = useTutorial()

const menuRef = ref<MenuInstance | null>(null)
const isMobile = computed<boolean>(() => window.innerWidth <= 768)

const pendingCount = computed<number>(() => {
  return availableTutorials.value.filter(t => t.status === 'not_started').length
})

const menuItems = computed<MenuItem[]>(() => {
  return availableTutorials.value.map(tutorial => {
    const status = tutorial.status as string;
    return {
      label: tutorial.title,
      icon: status === 'completed' ? 'pi pi-check-circle' : status === 'skipped' ? 'pi pi-minus-circle' : 'pi pi-play',
      command: () => replay(tutorial.slug),
    };
  });
})

function toggleMenu(event: Event): void {
  menuRef.value?.toggle(event)
}
</script>

<style scoped>
.tutorial-replay-wrapper {
  display: inline-flex;
  align-items: center;
}
</style>
